import { Component, OnInit, Output, EventEmitter, Input, ElementRef, ViewChild, ChangeDetectorRef, TemplateRef, HostListener, SimpleChanges } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  FormArray,
} from '@angular/forms';

import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { CoreService } from '../../../services/coreService/core.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { CreateFilterVm } from 'src/app/viewModels/core/core-vm';
import { ToastrService } from 'ngx-toastr';
import { LocaleConfig, LocaleService } from 'ngx-daterangepicker-material';
import { Moment } from 'moment';
import { start } from 'repl';
import { Console } from 'console';
import { ModuleName } from '../../../services/coreService/core.enum';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  providers: [LocaleService]
})

export class FilterComponent implements OnInit {
  @Output() closeFilter = new EventEmitter<boolean>();
  @Output() closeFilterAfterSave = new EventEmitter<boolean>();
  @Output() clearApplyFilter = new EventEmitter<boolean>();
  @Output() sendFilteredValue = new EventEmitter();

  saveFilterButtonDisabled = true;
  close: boolean = false;
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  myFormGroup: FormGroup;

  dropdownlist: any;

  newdropdownlist: any;

  multipleDropdownList: any;
  newmultipleDropdownList: any;

  checkBoxList: any;
  newcheckBoxList: any;

  radioButtonlist: any;
  newradioButtonlist: any;
  ImportanceList: any;
  chkStatusArry: any;

  TypeList: any = [];

  defaultFilterFieldsList: any;

  AllCityList: any;
  AllStateList: any;
  AllTypeList: any;
  AllZipCodeList: any;

  filterFieldsRequestModels:any [] = [];
  getSubFolderFieldsListResponseHolder: any;
  getTagListResponseHolder: any;
  getZipCodeListResponseHolder: any;
  getTypeListResponseHolder: any;
  getStateListResponseHolder: any;
  getCityListResponseHolder: any;
  getTypeModel = {
    databaseID: 0,
    userID: "",
    folderID: 0,
    organizationID: 0,
    officeID:0,
    OfficeIDList:[]
  };
  getTagListModel = {
    tagName: "",
    fieldID: 0,
    databaseID: 0,
    organizationID: 0,
    PageSize: 0
  };
  getZipCodeListModel = {
    databaseID: 0,
    organizationID: 0
  };
  getDefaultFilterFieldsModel = {
    folderID: 0,
    databaseID: 0,
    organizationID: 0,
    officeID:0
  };

  selectedDateLabel: string = "";
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  tagCtrl = new FormControl();
  filteredTags: Observable<string[]>;

  typeCtrl = new FormControl();
  filteredTypes: Observable<string[]>;

  importanceCtrl = new FormControl();
  filteredImportances: Observable<string[]>;

  zipcodeCtrl = new FormControl();
  filteredZipcodes: Observable<string[]>;


  zipcodes: string[] = [];
  allZipcodes: string[] = [];

  tags: string[] = [];
  allTags: string[] = [];

  types: string[] = [];
  allTypes: string[] = [];
  
  maxDate: Moment;
  minDate: Moment;

  importances: string[] = [];
  allImportances: string[] = [];

  states: string[] = [];
  allStates: string[] = [];

  citys: string[] = [];
  allCitys: string[] = [];
  filterName: string = "";
  isfilterExists:boolean=false;
  selectedtypesId: string[] = [];

  corefilterData = {
    userID: '',
    organizationID: 0,
    databaseID: 0,
  };
  coreFilterNameList: any[] = [];
  clearfilter: boolean = false;
  private _isfilterExistsSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isfilterExistsObs: Observable<boolean> = this._isfilterExistsSubject.asObservable();
  @Input() filterBindList: any[];  
  @Input() sendFromCoreFiltredName: string = "";

  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  @ViewChild('typeInput') typeInput: ElementRef<HTMLInputElement>;
  @ViewChild('importanceInput') importanceInput: ElementRef<HTMLInputElement>;
  @ViewChild('zipcodeInput') zipcodeInput: ElementRef<HTMLInputElement>;
  //@ViewChild('stateInput') stateInput: ElementRef<HTMLInputElement>;
  //@ViewChild('cityInput') cityInput: ElementRef<HTMLInputElement>;
  clickEventsubscription: Subscription;
  fieldlabelShow:boolean=false;
  
  permissionAsssign: any[] = [];
  folderListPermission: any[] = [];
  folderList: any[] = [];
  folderID:any;
  OfficeIDList: any = [];
  myOfficeID: any;
  orgModuleName:string="";

  constructor(private dialog: MatDialog,private formBuilder: FormBuilder,private coreService: CoreService,
    private encryptionAlgo: EncryptionService,private reusableClass: ReusableClasses,private statusConst: StatusConstant,
    private loaderService: LoaderService,private _dataSharingService: DataSharingService,private settingsService: SettingService,
    private createFilterVm: CreateFilterVm,private toastr: ToastrService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);

    this.filteredTags = this.tagCtrl.valueChanges.pipe(
      startWith(null),
      map((tag: string | null) => tag ? this._filterTag(tag) : this.allTags.slice()));

    this.filteredTypes = this.typeCtrl.valueChanges.pipe(
      startWith(null),
      map((type: string | null) => type ? this._filterType(type) : this.allTypes.slice()));

    this.filteredImportances = this.importanceCtrl.valueChanges.pipe(
      startWith(null),
      map((importance: string | null) => importance ? this._filterImportance(importance) : this.allImportances.slice()));

    this.filteredZipcodes = this.zipcodeCtrl.valueChanges.pipe(
      startWith(null),
      map((zipcode: string | null) => zipcode ? this._filterZipcode(zipcode) : this.allZipcodes.slice()));

      
      this.maxDate=moment();
      this.minDate=moment();
      
      var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
     });

    // this.filteredStates = this.stateCtrl.valueChanges.pipe(
    //   startWith(null),
    //   map((state: string | null) => state ? this._filterState(state) : this.allStates.slice()));

    // this.filteredCitys = this.cityCtrl.valueChanges.pipe(
    //   startWith(null),
    //   map((city: string | null) => city ? this._filterCity(city) : this.allCitys.slice()));
  }

  ngOnChanges(changes: SimpleChanges) {
   
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module=[];
    Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core);
    if(Module.length>0){     
      this.folderID = Module[0].folderID;
      this.orgModuleName = Module[0].orgModuleName;
     } 

    this.sendFromCoreFiltredName;
    this.filterBindList = changes.filterBindList.currentValue;
    //this.defaultFilterFieldsList = this.filterBindList;

    var taglist;
    var importancelist;
    //var statelist;
    //var citylist;
    var zipcodelist;
    let typelist;
    //let group = {};
   // this.myFormGroup = new FormGroup(group);

    if (this.sendFromCoreFiltredName != "All "+this.orgModuleName+"" && this.sendFromCoreFiltredName != "") {
      if (this.filterBindList != undefined && this.filterBindList.length > 0) {
        this.defaultFilterFieldsList.forEach(elementin => {
          let defaultvalue = this.filterBindList.find(x => x.fieldID == elementin.fieldID && x.childFieldType == elementin.childFieldType);
          elementin.defaultValue = defaultvalue != undefined ? defaultvalue.filterValue : ""
        });

        this.defaultFilterFieldsList;

        this._subscription();

        taglist = this.filterBindList.filter((e) => e.fieldTypeName == 'MultiSelect' && e.fieldName == 'Tags');
        if (taglist.length > 0 && taglist != undefined) {
          this.tags = [];
          if (taglist[0].filterValue != "") {
            this.tags = taglist[0].filterValue.split(',');
          }
          else {
            this.tags = [];
          }
        }
        else {
          this.tags = [];
        }

        importancelist = this.filterBindList.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Importance');
        if (importancelist.length > 0 && importancelist != undefined) {
          this.importances = [];
          if (importancelist[0].filterValue != "") {
            this.importances = importancelist[0].filterValue.split(',');
          }
          else {
            this.importances = [];
          }
        }
        else {
          this.importances = [];
        }

        // statelist = this.filterBindList.filter(
        //   (e) => e.fieldTypeName == 'Textbox' && e.childFieldType == 2
        // );
        // if (statelist.length > 0 && statelist != undefined) {
        //   this.states = [];
        //   if (statelist[0].filterValue != "") {
        //     this.states = statelist[0].filterValue.split(',');
        //   }
        //   else {
        //     this.states = [];
        //   }
        // }
        // else {
        //   this.states = [];
        // }

        // citylist = this.filterBindList.filter(
        //   (e) => e.fieldTypeName == 'Textbox' && e.childFieldType == 3
        // );
        // if (citylist.length > 0 && citylist != undefined) {
        //   this.citys = [];
        //   if (citylist[0].filterValue != "") {
        //     this.citys = citylist[0].filterValue.split(',');
        //   }
        //   else {
        //     this.citys = [];
        //   }
        // }
        // else {
        //   this.citys = [];
        // }

        zipcodelist = this.filterBindList.filter((e) => e.fieldTypeName == 'Textbox' && e.childFieldType == 4);
        if (zipcodelist.length > 0 && zipcodelist != undefined) {
          this.zipcodes = [];
          if (zipcodelist[0].filterValue != "") {
            this.zipcodes = zipcodelist[0].filterValue.split(',');
          }
          else {
            this.zipcodes = [];
          }
        }
        else {
          this.zipcodes = [];
        }

        typelist = this.filterBindList.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == "Type");
        if (typelist.length > 0 && typelist != undefined) {
          this.types = [];
          var drpId = typelist[0].filterValue.split(',');
          for (let i = 0; i < drpId.length; i++) {
            var id = drpId[i];
            var value = this.AllTypeList.filter((s) => s.subFolderID == parseInt(id));
            this.types.push(value[0].folderName);
          }
        }
        else {
          this.types = [];
        }
      }
    }
    if (this.sendFromCoreFiltredName == "All "+this.orgModuleName+"") {
      this.tags = [];
      //this.states = [];
     // this.citys = [];
      this.zipcodes = [];
      this.types = [];
      this.importances = [];
      this.saveFilterButtonDisabled = true;
      this.filterName = "";
      this.filterFieldsRequestModels = [];
      this.getDefaultFilterFields();

      this.sendFromCoreFiltredName = "";
    }
    if (this.sendFromCoreFiltredName == "") {
      // this._subscriptionFoAllCoreOrBlank();
      // this.clearFilterSilde(false)
      // this.defaultFilterFieldsList.forEach(element => {
      //   // if (element.fieldName == controlName) {
      //      element.label = " ";
      //   //  }
      //   });
      // this.tags = [];
      // this.states = [];
      // this.citys = [];
      // this.zipcodes = [];
      // this.types = [];
      // this.importances = [];
      // this.saveFilterButtonDisabled = true;
      // this.filterName = "";
      // this.filterFieldsRequestModels = [];
      // this.getDefaultFilterFields();     
    }

  }

  ngOnInit(): void {   
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module=[];
    Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core);
    if(Module.length>0){     
      this.folderID = Module[0].folderID;
     } 
    this.fieldlabelShow=false;
    this.clearfilter == false;
    this.filterBindList = [];
    this.saveFilterButtonDisabled = true;
    this.getDefaultFilterFields();
    this.getAllTagsList();
    this.getAllZipCodeList();
    this.getAllTypeList();
   // this.getStateDropdownList();
   // this.getCityDropdownList();
    let group = {};
    this.myFormGroup = new FormGroup(group);
  }

  //selected: any;
  // invalidDates: moment.Moment[] = [];
  // tooltips = [
  //   { date: moment(), text: 'Today is just unselectable' },
  //   { date: moment().add(2, 'days'), text: 'Yeeeees!!!' },
  // ];

  // selected = { label: 'Last Week' }
  //   selected = {
  //     {start: moment().subtract(6, 'days'), end: moment()}
  //     startDate: moment('2015-11-18T00:00Z'),
  //     //endDate: moment('2015-11-26T00:00Z'),
  //     //label:'This Week'
  // };
  ranges = {
    Today: [moment(), moment()],
    'This Week': [moment().startOf('week'), moment().endOf('week')],
    'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  };

  // form = this.formBuilder.group({
  //     selected: {
  //         startDate: moment().subtract(1, 'days').set({ hours: 0, minutes: 0 }),
  //         endDate: moment().subtract(1, 'days').set({ hours: 23, minutes: 59 }),
  //     },
  //     alwaysShowCalendars: true,
  //     keepCalendarOpeningWithRange: true,
  //     showRangeLabelOnInput: true,
  // });




  _rangeSelected = false;
  rangeClicked(range, controlName?: string): void {
    this.selectedDateLabel = range.label;
    this.defaultFilterFieldsList.forEach(element => {
      if (element.fieldName == controlName) {
        element.label = range.label;
      }
    });
    this._rangeSelected = true;
  }

  datesUpdated(range, fieldName, fieldID, fieldTypeID): void {
    this.fieldlabelShow=true;
    if (!this._rangeSelected) {
      this.defaultFilterFieldsList.forEach(element => {
        if (element.fieldName == fieldName) {
          element.label = 'Custom Range';
        }
      });
    }
    this._rangeSelected = false;    

    this.filterFieldsRequestModels = this.filterBindList;
    if (this.selectedDateLabel == undefined || this.selectedDateLabel == "") {
      if (range.startDate == null && range.endDate == null) {
        selectedDate = "";
        this.defaultFilterFieldsList.forEach(element => {
          if (element.fieldName == fieldName) {
            element.label = '';
          }
        });
      }
      if (!(range.startDate == null && range.endDate == null)) {
        selectedDate = (moment(range.startDate).format("MM/DD/YYYY") + ',' + moment(range.endDate).format("MM/DD/YYYY"));
      }
    }
    else {
      selectedDate = this.selectedDateLabel;
    }

    
    this.selectedDateLabel = "";
    var childFieldType;
    var fieldID;
    var selectedDate;
    var fieldTypeID;

    if (fieldName == "Date Added") {
      childFieldType = 6;
      fieldID = 0;
      fieldTypeID=null;
    }
    if (fieldName == "Last Viewed") {
      childFieldType = 5;
      fieldID = 0;
      fieldTypeID=null;
    }
    if (fieldName == "Next Touch") {
      childFieldType = 0;
      fieldID = fieldID;
      fieldTypeID=fieldTypeID;
    }
    if (fieldName == "Last Touch") {
      childFieldType = 0;
      fieldID = fieldID;
      fieldTypeID=fieldTypeID;
    }
    var filtervalue = selectedDate;

    var filterFieldsRequestModelDate = {
      filterValue: filtervalue,
      childFieldType: childFieldType,
      fieldID: fieldID,
      fieldTypeID: fieldTypeID,
      organizationID: Number(this.organizationId)
    }
    var found = false;
    this.filterFieldsRequestModels.forEach(s => {
      if (!found) {
        if (s.fieldID == filterFieldsRequestModelDate.fieldID
          && s.childFieldType == filterFieldsRequestModelDate.childFieldType
          && s.fieldTypeID == filterFieldsRequestModelDate.fieldTypeID) {
          s.filterValue = filtervalue,
          s.childFieldType = childFieldType;
          s.fieldID = fieldID;
          s.fieldTypeID = fieldTypeID;
          s.organizationID = Number(this.organizationId);
          found = true;
        }
      }
    });

    if (!found) {
      this.filterFieldsRequestModels.push(filterFieldsRequestModelDate);
    }

    this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter((m) => m.filterValue != "");

    if (this.filterFieldsRequestModels.length > 0) {
      this.saveFilterButtonDisabled = false;
      this.sendFilteredValue.emit(this.filterFieldsRequestModels);
      //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
    } else {
      this.saveFilterButtonDisabled = true;
      this.sendFilteredValue.emit(this.filterFieldsRequestModels);
      //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
    }
  }

  // Get All Default Filter Fields
  getDefaultFilterFields() {
    this.getDefaultFilterFieldsModel.databaseID = Number(this.databaseId);
    this.getDefaultFilterFieldsModel.organizationID = Number(this.organizationId);
    this.getDefaultFilterFieldsModel.folderID = this.folderID;//17;
    this.getDefaultFilterFieldsModel.officeID=this.myOfficeID;
    this.coreService.geDefaultFilterFieldsList(this.getDefaultFilterFieldsModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {

          this.defaultFilterFieldsList = response.data;

          this.ImportanceList = response.data.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Importance');

          if (this.ImportanceList.length > 0) {
            for (let i = 0; i < this.ImportanceList.length; i++) {
              var valueImp = this.ImportanceList[i].defaultValue.split(',');
              this.allImportances = valueImp;
            }
          }

          this.defaultFilterFieldsList.forEach((formControl) => {
            this.myFormGroup.addControl(formControl.fieldName, this.formBuilder.control(''));
          });

          this.dropdownlist = this.defaultFilterFieldsList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');

          this.multipleDropdownList = this.defaultFilterFieldsList.filter((s) => s.fieldTypeName == 'MultiSelect');

          if (this.dropdownlist.length > 0) {
            var fieldListdrp = [];
            var value;
            for (let i = 0; i < this.dropdownlist.length; i++) {
              value = this.dropdownlist[i].defaultValue.split(',');
              var FieldsDrp = {
                FieldValue: this.dropdownlist[i].fieldName,
                value: value,
              };
              fieldListdrp.push(FieldsDrp);
            }
            this.dropdownlist = fieldListdrp;
          }

          if (this.multipleDropdownList.length > 0) {
            var fieldmulListdrp = [];
            var value;
            for (let i = 0; i < this.multipleDropdownList.length; i++) {
              value = this.multipleDropdownList[i].defaultValue.split(',');
              var FieldsMulDrp = {
                FieldValue: this.multipleDropdownList[i].fieldName,
                value: value,
              };
              fieldmulListdrp.push(FieldsMulDrp);
            }
            this.multipleDropdownList = fieldmulListdrp;
          }
        }
      }
    });
  }

  _subscriptionFoAllCoreOrBlank() {
    this.defaultFilterFieldsList;
    this.myFormGroup;
    if(this.defaultFilterFieldsList !=undefined){
      this.defaultFilterFieldsList.forEach(element => {
        if (element.fieldTypeName == "Date") {
          this.myFormGroup.get(element.fieldName).setValue(null);              
        }        
      });
    }    
  }

  _subscription() {
    this.defaultFilterFieldsList;
    this.myFormGroup;
    this.defaultFilterFieldsList.forEach(element => {
      if (element.fieldTypeName == "Date") {
        if (element.defaultValue == null || element.defaultValue == undefined) {
          element.defaultValue = "";
        }
        if (typeof element.defaultValue == 'string' && element.defaultValue != "") {
          for (var property in this.ranges) {
            if (property == element.defaultValue) {
              element.defaultValue = this.ranges[property]
              element.label = property
            }
          }
        }
        if (element.defaultValue != "") {         
          var ReqModel = {
            startDate: element.defaultValue[0],
            endDate: element.defaultValue[1]
          }
          this.myFormGroup.get(element.fieldName).setValue(ReqModel);
        }       
      }
    });
  }

  getdropdownlist(fieldName) {
    var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
    return _newdropdownlist[0].value;
  }

  getMuldropdownlist(fieldName) {
    var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
    return _newMuldropdownlist[0].value;
  }


  private _filterTag(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter(tag => tag.toLowerCase().indexOf(filterValue) === 0);
  }

  addTags(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();
    input.value = '';
    // // Add tag
    // if ((value || '').trim()) {
    //   var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
    //   const index = arrToUp.indexOf(value.trim());

    //   if (index >= 0) {
    //     //this.fruits.splice(index, 1);
    //   }
    //   else {
    //     this.tags.push(event.value.trim());
    //   }
    // }
    // // Reset the input value
    // if (input) {
    //   input.value = '';
    // }

    // this.tagCtrl.setValue(null);
  }

  removeTags(tag: string, fieldName, field, fieldTypeID, childFieldType): void {
    this.filterFieldsRequestModels = this.filterBindList;
    const index = this.tags.indexOf(tag);
    if (index >= 0) {
      this.tags.splice(index, 1);

      var filtervalue = this.tags.join(',');
      var filterFieldsRequestModelTag = {
        filterValue: filtervalue,
        childFieldType: childFieldType,
        fieldID: field,
        fieldTypeID: fieldTypeID,
        organizationID: Number(this.organizationId)
      }
      var found = false;
      this.filterFieldsRequestModels.forEach(s => {
        if (!found) {
          if (s.fieldID == filterFieldsRequestModelTag.fieldID
            && s.childFieldType == filterFieldsRequestModelTag.childFieldType
            && s.fieldTypeID == filterFieldsRequestModelTag.fieldTypeID) {
            s.filterValue = filtervalue,
              s.childFieldType = childFieldType;
            s.fieldID = field;
            s.fieldTypeID = fieldTypeID;
            s.organizationID = Number(this.organizationId);
            found = true;
          }
        }
      });
      if (!found) {
        this.filterFieldsRequestModels.push(filterFieldsRequestModelTag);
      }

      this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter((m) => m.filterValue != "");

      if (this.filterFieldsRequestModels.length > 0) {
        this.saveFilterButtonDisabled = false;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
        //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      } else {
        this.saveFilterButtonDisabled = true;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
       // this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      }
    }
  }

  selectedTags(event: MatAutocompleteSelectedEvent, fieldName, field, fieldTypeID, childFieldType): void {
    this.filterFieldsRequestModels = this.filterBindList;
    const index = this.tags.indexOf(event.option.viewValue);
    if (index >= 0) {
      this.tagInput.nativeElement.value = '';
    }
    else {
      this.tags.push(event.option.viewValue);
      this.tagInput.nativeElement.value = '';
      this.tagCtrl.setValue(null);

      var filtervalue = this.tags.join(',');
      var filterFieldsRequestModelTag = {
        filterValue: filtervalue,
        childFieldType: childFieldType,
        fieldID: field,
        fieldTypeID: fieldTypeID,
        organizationID: Number(this.organizationId)
      }
      var found = false;
      this.filterFieldsRequestModels.forEach(s => {
        if (!found) {
          if (s.fieldID == filterFieldsRequestModelTag.fieldID
            && s.childFieldType == filterFieldsRequestModelTag.childFieldType
            && s.fieldTypeID == filterFieldsRequestModelTag.fieldTypeID) {
            s.filterValue = filtervalue,
              s.childFieldType = childFieldType;
            s.fieldID = field;
            s.fieldTypeID = fieldTypeID;
            s.organizationID = Number(this.organizationId);
            found = true;
          }
        }
      });
      if (!found) {
        this.filterFieldsRequestModels.push(filterFieldsRequestModelTag);
      }

      this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter((m) => m.filterValue != "");

      if (this.filterFieldsRequestModels.length > 0) {
        this.saveFilterButtonDisabled = false;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
        //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      } else {
        this.saveFilterButtonDisabled = true;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
        //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      }
    }
  }


  private _filterType(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTypes.filter(type => type.toLowerCase().indexOf(filterValue) === 0);
  }

  addType(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();
    input.value = '';
    // // Add type
    // if ((value || '').trim()) {
    //   var arrToUp = String.prototype.toLowerCase.apply(this.types).split(",");
    //   const index = arrToUp.indexOf(value.trim());

    //   if (index >= 0) {
    //     //this.fruits.splice(index, 1);
    //   }
    //   else {
    //     this.types.push(event.value.trim());
    //   }
    // }
    // // Reset the input value
    // if (input) {
    //   input.value = '';
    // }

    // this.typeCtrl.setValue(null);
  }

  removeType(type: string, fieldName, field, fieldTypeID, childFieldType): void {
    this.filterFieldsRequestModels = this.filterBindList;
    const index = this.types.indexOf(type);
    if (index >= 0) {
      this.types.splice(index, 1);
      if (this.types.length > 0) {
        this.selectedtypesId = [];
        for (let i = 0; i < this.types.length; i++) {
          var drpValue = this.types[i];
          var value = this.AllTypeList.filter((s) => s.folderName == drpValue);
          var newvalue = value[0].subFolderID;
          this.selectedtypesId.push(newvalue);
        }
      }
      if (this.types.length == 0) {
        this.selectedtypesId = this.types;
      }
      this.AllTypeList;

      var filtervalue = this.selectedtypesId.join(',');
      var filterFieldsRequestModeltype = {
        filterValue: filtervalue,
        childFieldType: childFieldType,
        fieldID: field,
        fieldTypeID: fieldTypeID,
        organizationID: Number(this.organizationId)
      }

      var found = false;
      this.filterFieldsRequestModels.forEach(s => {
        if (!found) {
          if (s.fieldID == filterFieldsRequestModeltype.fieldID
            && s.childFieldType == filterFieldsRequestModeltype.childFieldType
            && s.fieldTypeID == filterFieldsRequestModeltype.fieldTypeID) {
            s.filterValue = filtervalue,
              s.childFieldType = childFieldType;
            s.fieldID = field;
            s.fieldTypeID = fieldTypeID;
            s.organizationID = Number(this.organizationId);
            found = true;
          }
        }
      });
      if (!found) {
        this.filterFieldsRequestModels.push(filterFieldsRequestModeltype);
      }

      this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter((m) => m.filterValue != "");

      if (this.filterFieldsRequestModels.length > 0) {
        this.saveFilterButtonDisabled = false;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
        //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      } else {
        this.saveFilterButtonDisabled = true;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
        //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      }
    }
  }

  selectedType(event: MatAutocompleteSelectedEvent, fieldName, field, fieldTypeID, childFieldType): void {
    this.filterFieldsRequestModels = this.filterBindList;
    const index = this.types.indexOf(event.option.viewValue);
    if (index >= 0) {
      this.typeInput.nativeElement.value = '';
    }
    else {
      this.types.push(event.option.viewValue);
      this.typeInput.nativeElement.value = '';
      this.typeCtrl.setValue(null);

      if (this.types.length > 0) {
        this.selectedtypesId = [];
        for (let i = 0; i < this.types.length; i++) {
          var drpValue = this.types[i];
          var value = this.AllTypeList.filter((s) => s.folderName == drpValue);
          var newvalue = value[0].subFolderID;
          this.selectedtypesId.push(newvalue);
        }
      }

      this.AllTypeList;

      var filtervalue = this.selectedtypesId.join(',');
      var filterFieldsRequestModeltype = {
        filterValue: filtervalue,
        childFieldType: childFieldType,
        fieldID: field,
        fieldTypeID: fieldTypeID,
        organizationID: Number(this.organizationId)
      }

      var found = false;
      this.filterFieldsRequestModels.forEach(s => {
        if (!found) {
          if (s.fieldID == filterFieldsRequestModeltype.fieldID
            && s.childFieldType == filterFieldsRequestModeltype.childFieldType
            && s.fieldTypeID == filterFieldsRequestModeltype.fieldTypeID) {
            s.filterValue = filtervalue,
            s.childFieldType = childFieldType;
            s.fieldID = field;
            s.fieldTypeID = fieldTypeID;
            s.organizationID = Number(this.organizationId);
            found = true;
          }
        }
      });
      if (!found) {
        this.filterFieldsRequestModels.push(filterFieldsRequestModeltype);
      }

      this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter((m) => m.filterValue != "");

      if (this.filterFieldsRequestModels.length > 0) {
        this.saveFilterButtonDisabled = false;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
        //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      } else {
        this.saveFilterButtonDisabled = true;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
       // this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      }
    }
  }

  private _filterImportance(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allImportances.filter(importance => importance.toLowerCase().indexOf(filterValue) === 0);
  }

  addImportance(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();
    input.value = '';
    // // Add importance
    // if ((value || '').trim()) {
    //   var arrToUp = String.prototype.toLowerCase.apply(this.importances).split(",");
    //   const index = arrToUp.indexOf(value.trim());

    //   if (index >= 0) {
    //     //this.fruits.splice(index, 1);
    //   }
    //   else {
    //     this.importances.push(event.value.trim());
    //   }
    // }
    // // Reset the input value
    // if (input) {
    //   input.value = '';
    // }

    // this.importanceCtrl.setValue(null);
  }

  removeImportance(importance: string, fieldName, field, fieldTypeID, childFieldType): void {
    this.filterFieldsRequestModels = this.filterBindList;
    const index = this.importances.indexOf(importance);
    if (index >= 0) {
      this.importances.splice(index, 1);
      var filtervalue = this.importances.join(',');
      var filterFieldsRequestModelimportances = {
        filterValue: filtervalue,
        childFieldType: childFieldType,
        fieldID: field,
        fieldTypeID: fieldTypeID,
        organizationID: Number(this.organizationId)
      }
      var found = false;
      this.filterFieldsRequestModels.forEach(s => {
        if (!found) {
          if (s.fieldID == filterFieldsRequestModelimportances.fieldID
            && s.childFieldType == filterFieldsRequestModelimportances.childFieldType
            && s.fieldTypeID == filterFieldsRequestModelimportances.fieldTypeID) {
            s.filterValue = filtervalue,
            s.childFieldType = childFieldType;
            s.fieldID = field;
            s.fieldTypeID = fieldTypeID;
            s.organizationID = Number(this.organizationId);
            found = true;
          }
        }
      });
      if (!found) {
        this.filterFieldsRequestModels.push(filterFieldsRequestModelimportances);
      }

      this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter((m) => m.filterValue != "");

      if (this.filterFieldsRequestModels.length > 0) {
        this.saveFilterButtonDisabled = false;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
        //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      } else {
        this.saveFilterButtonDisabled = true;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
       // this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      }

    }
  }

  selectedImportance(event: MatAutocompleteSelectedEvent, fieldName, field, fieldTypeID, childFieldType): void {
    this.filterFieldsRequestModels = this.filterBindList;
    const index = this.importances.indexOf(event.option.viewValue);
    if (index >= 0) {
      this.importanceInput.nativeElement.value = '';
    }
    else {
      this.importances.push(event.option.viewValue);
      this.importanceInput.nativeElement.value = '';
      this.importanceCtrl.setValue(null);

      var filtervalue = this.importances.join(',');
      var filterFieldsRequestModelimportances = {
        filterValue: filtervalue,
        childFieldType: childFieldType,
        fieldID: field,
        fieldTypeID: fieldTypeID,
        organizationID: Number(this.organizationId)
      }
      var found = false;
      this.filterFieldsRequestModels.forEach(s => {
        if (!found) {
          if (s.fieldID == filterFieldsRequestModelimportances.fieldID
            && s.childFieldType == filterFieldsRequestModelimportances.childFieldType
            && s.fieldTypeID == filterFieldsRequestModelimportances.fieldTypeID) {
            s.filterValue = filtervalue,
            s.childFieldType = childFieldType;
            s.fieldID = field;
            s.fieldTypeID = fieldTypeID;
            s.organizationID = Number(this.organizationId);
            found = true;
          }
        }
      });
      if (!found) {
        this.filterFieldsRequestModels.push(filterFieldsRequestModelimportances);
      }

      this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter((m) => m.filterValue != "");

      if (this.filterFieldsRequestModels.length > 0) {
        this.myFormGroup.markAsTouched();
        this.myFormGroup.markAsDirty();
        this.saveFilterButtonDisabled = false;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
        //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      } else {
        this.saveFilterButtonDisabled = true;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
       // this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      }

    }
  }


  private _filterZipcode(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allZipcodes.filter(zipcode => zipcode.toLowerCase().indexOf(filterValue) === 0);
  }

  addZipCode(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();
    input.value = '';
    // // Add zipcode
    // if ((value || '').trim()) {
    //   var arrToUp = String.prototype.toLowerCase.apply(this.zipcodes).split(",");
    //   const index = arrToUp.indexOf(value.trim());

    //   if (index >= 0) {
    //     //this.fruits.splice(index, 1);
    //   }
    //   else {
    //     this.zipcodes.push(event.value.trim());
    //   }
    // }
    // // Reset the input value
    // if (input) {
    //   input.value = '';
    // }

    // this.zipcodeCtrl.setValue(null);
  }

  removeZipCode(zipcode: string, fieldName, field, fieldTypeID, childFieldType): void {
    this.filterFieldsRequestModels = this.filterBindList;
    const index = this.zipcodes.indexOf(zipcode);
    if (index >= 0) {
      this.zipcodes.splice(index, 1);

      var filtervalue = this.zipcodes.join(',');
      var filterFieldsRequestModelzipcode = {
        filterValue: filtervalue,
        childFieldType: childFieldType,
        fieldID: field,
        fieldTypeID: fieldTypeID,
        organizationID: Number(this.organizationId)
      }
      var found = false;
      this.filterFieldsRequestModels.forEach(s => {
        if (!found) {
          if (s.fieldID == filterFieldsRequestModelzipcode.fieldID && s.childFieldType == filterFieldsRequestModelzipcode.childFieldType) {
            s.filterValue = filtervalue,
            s.childFieldType = childFieldType;
            s.fieldID = field;
            s.fieldTypeID = fieldTypeID;
            s.organizationID = Number(this.organizationId);
            found = true;
          }
        }
      });
      if (!found) {
        this.filterFieldsRequestModels.push(filterFieldsRequestModelzipcode);
      }

      this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter((m) => m.filterValue != "");

      if (this.filterFieldsRequestModels.length > 0) {
        this.saveFilterButtonDisabled = false;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
       // this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      } else {
        this.saveFilterButtonDisabled = true;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
        //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      }

    }
  }

  selectedZipCode(event: MatAutocompleteSelectedEvent, fieldName, field, fieldTypeID, childFieldType): void {
    this.filterFieldsRequestModels = this.filterBindList;
    const index = this.zipcodes.indexOf(event.option.viewValue);
    if (index >= 0) {
      this.zipcodeInput.nativeElement.value = '';
    }
    else {
      this.zipcodes.push(event.option.viewValue);
      this.zipcodeInput.nativeElement.value = '';
      this.zipcodeCtrl.setValue(null);

      var filtervalue = this.zipcodes.join(',');
      var filterFieldsRequestModelzipcode = {
        filterValue: filtervalue,
        childFieldType: childFieldType,
        fieldID: field,
        fieldTypeID: fieldTypeID,
        organizationID: Number(this.organizationId)
      }

      var found = false;
      this.filterFieldsRequestModels.forEach(s => {
        if (!found) {
          if (s.fieldID == filterFieldsRequestModelzipcode.fieldID && s.childFieldType == filterFieldsRequestModelzipcode.childFieldType) {
            s.filterValue = filtervalue,
            s.childFieldType = childFieldType;
            s.fieldID = field;
            s.fieldTypeID = fieldTypeID;
            s.organizationID = Number(this.organizationId);
            found = true;
          }
        }
      });
      if (!found) {
        this.filterFieldsRequestModels.push(filterFieldsRequestModelzipcode);
      }

      this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter((m) => m.filterValue != "");

      if (this.filterFieldsRequestModels.length > 0) {
        this.saveFilterButtonDisabled = false;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
        //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      } else {
        this.saveFilterButtonDisabled = true;
        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
        //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
      }

    }
  }

  // private _filterState(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //   return this.allStates.filter(state => state.toLowerCase().indexOf(filterValue) === 0);
  // }

  // addState(event: MatChipInputEvent): void {
  //   const input = event.input;
  //   const value = event.value.toLowerCase();
  //   input.value = '';
  //   // // Add state
  //   // if ((value || '').trim()) {
  //   //   var arrToUp = String.prototype.toLowerCase.apply(this.states).split(",");
  //   //   const index = arrToUp.indexOf(value.trim());

  //   //   if (index >= 0) {
  //   //     //this.fruits.splice(index, 1);
  //   //   }
  //   //   else {
  //   //     this.states.push(event.value.trim());
  //   //   }
  //   // }
  //   // // Reset the input value
  //   // if (input) {
  //   //   input.value = '';
  //   // }

  //   // this.stateCtrl.setValue(null);
  // }

  // removeState(state: string, fieldName, field, fieldTypeID, childFieldType): void {
  //   this.filterFieldsRequestModels = this.filterBindList;
  //   const index = this.states.indexOf(state);
  //   if (index >= 0) {
  //     this.states.splice(index, 1);

  //     var filtervalue = this.states.join(',');
  //     var filterFieldsRequestModelstate = {
  //       filterValue: filtervalue,
  //       childFieldType: childFieldType,
  //       fieldID: field,
  //       fieldTypeID: fieldTypeID,
  //       organizationID: Number(this.organizationId)
  //     }

  //     var found = false;
  //     this.filterFieldsRequestModels.forEach(s => {
  //       if (!found) {
  //         if (s.fieldID == filterFieldsRequestModelstate.fieldID
  //           && s.childFieldType == filterFieldsRequestModelstate.childFieldType) {
  //           s.filterValue = filtervalue,
  //             s.childFieldType = childFieldType;
  //           s.fieldID = field;
  //           s.fieldTypeID = fieldTypeID;
  //           s.organizationID = Number(this.organizationId);
  //           found = true;
  //         }
  //       }
  //     });
  //     if (!found) {
  //       this.filterFieldsRequestModels.push(filterFieldsRequestModelstate);
  //     }

  //     this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter(
  //       (m) => m.filterValue != ""
  //     );

  //     if (this.filterFieldsRequestModels.length > 0) {
  //       this.saveFilterButtonDisabled = false;
           //this.sendFilteredValue.emit(this.filterFieldsRequestModels);
  //       //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
  //     } else {
  //       this.saveFilterButtonDisabled = true;
          //this.sendFilteredValue.emit(this.filterFieldsRequestModels); 
  //      // this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
  //     }

  //   }
  // }

  // selectedState(event: MatAutocompleteSelectedEvent, fieldName, field, fieldTypeID, childFieldType): void {
  //   this.filterFieldsRequestModels = this.filterBindList;
  //   const index = this.states.indexOf(event.option.viewValue);
  //   if (index >= 0) {
  //     this.stateInput.nativeElement.value = '';
  //   }
  //   else {
  //     this.states.push(event.option.viewValue);
  //     this.stateInput.nativeElement.value = '';
  //     this.stateCtrl.setValue(null);

  //     var filtervalue = this.states.join(',');
  //     var filterFieldsRequestModelstate = {
  //       filterValue: filtervalue,
  //       childFieldType: childFieldType,
  //       fieldID: field,
  //       fieldTypeID: fieldTypeID,
  //       organizationID: Number(this.organizationId)
  //     }

  //     var found = false;
  //     this.filterFieldsRequestModels.forEach(s => {
  //       if (!found) {
  //         if (s.fieldID == filterFieldsRequestModelstate.fieldID && s.childFieldType == filterFieldsRequestModelstate.childFieldType) {
  //           s.filterValue = filtervalue,
  //             s.childFieldType = childFieldType;
  //           s.fieldID = field;
  //           s.fieldTypeID = fieldTypeID;
  //           s.organizationID = Number(this.organizationId);
  //           found = true;
  //         }
  //       }
  //     });
  //     if (!found) {
  //       this.filterFieldsRequestModels.push(filterFieldsRequestModelstate);
  //     }

  //     this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter(
  //       (m) => m.filterValue != ""
  //     );

  //     if (this.filterFieldsRequestModels.length > 0) {
  //       this.saveFilterButtonDisabled = false;
  //this.sendFilteredValue.emit(this.filterFieldsRequestModels);
  //      // this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
  //     } else {
  //       this.saveFilterButtonDisabled = true;
  // this.sendFilteredValue.emit(this.filterFieldsRequestModels);
  //       //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
  //     }
  //   }
  // }

  // private _filterCity(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //   return this.allCitys.filter(city => city.toLowerCase().indexOf(filterValue) === 0);
  // }

  // addCity(event: MatChipInputEvent): void {
  //   const input = event.input;
  //   const value = event.value.toLowerCase();
  //   input.value = '';
  //   // // Add City
  //   // if ((value || '').trim()) {
  //   //   var arrToUp = String.prototype.toLowerCase.apply(this.citys).split(",");
  //   //   const index = arrToUp.indexOf(value.trim());

  //   //   if (index >= 0) {
  //   //     //this.fruits.splice(index, 1);
  //   //   }
  //   //   else {
  //   //     this.citys.push(event.value.trim());
  //   //   }
  //   // }
  //   // // Reset the input value
  //   // if (input) {
  //   //   input.value = '';
  //   // }

  //   // this.cityCtrl.setValue(null);
  // }

  // removeCity(city: string, fieldName, field, fieldTypeID, childFieldType): void {
  //   this.filterFieldsRequestModels = this.filterBindList;
  //   const index = this.citys.indexOf(city);
  //   if (index >= 0) {
  //     this.citys.splice(index, 1);

  //     var filtervalue = this.citys.join(',');
  //     var filterFieldsRequestModelcity = {
  //       filterValue: filtervalue,
  //       childFieldType: childFieldType,
  //       fieldID: field,
  //       fieldTypeID: fieldTypeID,
  //       organizationID: Number(this.organizationId)
  //     }
  //     var found = false;
  //     this.filterFieldsRequestModels.forEach(s => {
  //       if (!found) {
  //         if (s.fieldID == filterFieldsRequestModelcity.fieldID && s.childFieldType == filterFieldsRequestModelcity.childFieldType) {
  //           s.filterValue = filtervalue,
  //             s.childFieldType = childFieldType;
  //           s.fieldID = field;
  //           s.fieldTypeID = fieldTypeID;
  //           s.organizationID = Number(this.organizationId);
  //           found = true;
  //         }
  //       }
  //     });
  //     if (!found) {
  //       this.filterFieldsRequestModels.push(filterFieldsRequestModelcity);
  //     }
  //     this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter(
  //       (m) => m.filterValue != ""
  //     );

  //     if (this.filterFieldsRequestModels.length > 0) {
  //        this.saveFilterButtonDisabled = false;
  //        this.sendFilteredValue.emit(this.filterFieldsRequestModels);
  ////      this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
  //     } else {        
  //         this.saveFilterButtonDisabled = true;
  //         this.sendFilteredValue.emit(this.filterFieldsRequestModels);
  // //      this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
  //     }

  //   }
  // }

  // selectedCity(event: MatAutocompleteSelectedEvent, fieldName, field, fieldTypeID, childFieldType): void {
  //   this.filterFieldsRequestModels = this.filterBindList;
  //   const index = this.citys.indexOf(event.option.viewValue);
  //   if (index >= 0) {
  //     this.cityInput.nativeElement.value = '';
  //   }
  //   else {
  //     this.citys.push(event.option.viewValue);
  //     this.cityInput.nativeElement.value = '';
  //     this.cityCtrl.setValue(null);

  //     var filtervalue = this.citys.join(',');
  //     var filterFieldsRequestModelcity = {
  //       filterValue: filtervalue,
  //       childFieldType: childFieldType,
  //       fieldID: field,
  //       fieldTypeID: fieldTypeID,
  //       organizationID: Number(this.organizationId)
  //     }

  //     var found = false;
  //     this.filterFieldsRequestModels.forEach(s => {
  //       if (!found) {
  //         if (s.fieldID == filterFieldsRequestModelcity.fieldID && s.childFieldType == filterFieldsRequestModelcity.childFieldType) {
  //           s.filterValue = filtervalue,
  //           s.childFieldType = childFieldType;
  //           s.fieldID = field;
  //           s.fieldTypeID = fieldTypeID;
  //           s.organizationID = Number(this.organizationId);
  //           found = true;
  //         }
  //       }
  //     });
  //     if (!found) {
  //       this.filterFieldsRequestModels.push(filterFieldsRequestModelcity);
  //     }

  //     this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter(
  //       (m) => m.filterValue != ""
  //     );

  //     if (this.filterFieldsRequestModels.length > 0) {
  //       this.saveFilterButtonDisabled = false;
  //       this.sendFilteredValue.emit(this.filterFieldsRequestModels);
  ////     this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
  //     } else {        
  //        this.saveFilterButtonDisabled = true;
 //         this.sendFilteredValue.emit(this.filterFieldsRequestModels);
  // //     this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
  //     }
  //   }
  // }


  // get Tag List
 
  getAllTagsList() {
    this.getTagListModel.databaseID = Number(this.databaseId);
    this.getTagListModel.organizationID = Number(this.organizationId);
    this.getTagListModel.tagName = '';    
    this.getTagListModel.PageSize = 0;
    this.settingsService.getAllTagsList(this.getTagListModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.allTags = this.getTagListResponseHolder.data.tagNames;
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  // get All Zip code List
  getAllZipCodeList() {
    this.getZipCodeListModel.databaseID = Number(this.databaseId);
    this.getZipCodeListModel.organizationID = Number(this.organizationId);
    this.settingsService.getAllZipCodeList(this.getZipCodeListModel).subscribe(response => {
      if (response != undefined) {
        this.getZipCodeListResponseHolder = response;
        if (this.getZipCodeListResponseHolder.status == this.statusConst.statusSuccess) {
          this.AllZipCodeList = this.getZipCodeListResponseHolder.data;
          if (this.AllZipCodeList.length > 0) {
            for (let i = 0; i < this.AllZipCodeList.length; i++) {
              var value = this.AllZipCodeList[i].zipCodeValue;
              this.allZipcodes.push(value);
            }
          }
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  // get All Type List
  getAllTypeList() {
    this.getTypeModel.databaseID = Number(this.databaseId);
    this.getTypeModel.organizationID = Number(this.organizationId);
    this.getTypeModel.userID = this.currentUser.UID;
    this.getTypeModel.folderID = this.folderID;//17;
    this.getTypeModel.officeID = this.myOfficeID;//17;
    this.getTypeModel.OfficeIDList = this.OfficeIDList;//17;
    this.settingsService.getAllTypeList(this.getTypeModel).subscribe(response => {
      if (response != undefined) {
        this.getTypeListResponseHolder = response;
        if (this.getTypeListResponseHolder.status == this.statusConst.statusSuccess) {
          this.AllTypeList = this.getTypeListResponseHolder.data;
          if (this.AllTypeList.length > 0) {
            for (let i = 0; i < this.AllTypeList.length; i++) {
              var value = this.AllTypeList[i].folderName;
              this.allTypes.push(value);
            }
          }
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  // get all state for US Country
  getStateDropdownList() {
    this.settingsService.getStateList(231).subscribe((response) => {
        if (response) {
          this.getStateListResponseHolder = response;
          if (this.getStateListResponseHolder.status == this.statusConst.statusSuccess) {
            this.AllStateList = this.getStateListResponseHolder.data;
            if (this.AllStateList.length > 0) {
              for (let i = 0; i < this.AllStateList.length; i++) {
                var value = this.AllStateList[i].stateName;
                this.allStates.push(value);
              }
            }
          }
        }
      });

  }

  // get all City for US Country
  getCityDropdownList() {
    this.settingsService.getCityList(0).subscribe((response) => {
      if (response) {
        this.getCityListResponseHolder = response;
        if (this.getCityListResponseHolder.status == this.statusConst.statusSuccess) {
          this.AllCityList = this.getCityListResponseHolder.data;
          if (this.AllCityList.length > 0) {
            for (let i = 0; i < this.AllCityList.length; i++) {
              var value = this.AllCityList[i].cityName;
              this.allCitys.push(value);
            }
          }
        }
      }
    });
  }


  openDialogWithRef(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
    });
  }

  filters(value) {
    if(value!='' && value!=null){
     this.createFilterButton=true;
    }else{
     this.createFilterButton=false;
    }
   }
   
  spinner:boolean=false;
  createFilterButton:boolean=false;

  //Create Filter or add Filter
  createFilter() {
    if (this.filterName.trim() == "" || this.filterName.trim() == null || this.filterName.trim() == undefined) {
      this.toastr.warning("please enter filter name", '', {
        timeOut: 3000,
      });
      return;
    }
    let localFilters =sessionStorage.getItem('localFilters').split(',');
    localFilters = localFilters.map(v => v.toLowerCase());
    this.isfilterExists= localFilters.indexOf(this.filterName.toLowerCase()) > -1
    if(this.isfilterExists){
     this.toastr.warning("Filter name already exists.", '', {
       timeOut: 3000,
     });
     return;
    }
    this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter((m) => m.filterValue != "");

    this.createFilterVm.userID = this.currentUser.UID;
    this.createFilterVm.organizationID = Number(this.organizationId);
    this.createFilterVm.databaseID = Number(this.databaseId);
    this.createFilterVm.filterName = this.filterName.trim();
    this.createFilterVm.folderID = this.folderID;//17;
    this.createFilterVm.isDefault = false;
    this.createFilterVm.isFavourite = false;
    this.createFilterVm.filterFieldsRequestModels = this.filterFieldsRequestModels;
    this.createFilterVm.officeID = this.myOfficeID;    
    this.spinner=true;
    this.createFilterButton=false;
    this.coreService.CreateFilter(this.createFilterVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner=false;
        this.createFilterButton=false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.closefilter();
          this.closeFilterSildeAfterSave(false);
          this.toastr.success("Filter save successfully", '', {
            timeOut: 3000,
          });
        }
        else {
          this.spinner=false;
          this.createFilterButton=true;
          this.toastr.warning(response.message, '', {
            timeOut: 3000,
          });
        }
      }else{
        this.spinner=false;
        this.createFilterButton=true;
      }
    });
  }


  onSearchChange(searchValue: string, fieldname, field, fieldTypeID,childFieldType): void {
    this.filterFieldsRequestModels = this.filterBindList;
    var childFieldTypeId;
    if(childFieldType > 0){
      childFieldTypeId = childFieldType;
    }
    else{
      childFieldTypeId =0;
    }
    var filterFieldsRequestModel = {
      filterValue: searchValue,
      childFieldType: childFieldTypeId,//0,
      fieldID: field,
      fieldTypeID: fieldTypeID,
      organizationID: Number(this.organizationId)
    }
    var found = false;
    this.filterFieldsRequestModels.forEach(s => {
      if (!found) {
        if (s.fieldID == filterFieldsRequestModel.fieldID && s.childFieldType == filterFieldsRequestModel.childFieldType) {
          s.filterValue = searchValue;
          s.childFieldType = childFieldTypeId;
          s.fieldID = field;
          s.fieldTypeID = fieldTypeID;
          s.organizationID = Number(this.organizationId);
          found = true;
        }
      }
    });
    if (!found) {
    this.filterFieldsRequestModels.push(filterFieldsRequestModel);    }

    this.filterFieldsRequestModels = this.filterFieldsRequestModels.filter((m) => m.filterValue != "");

    if (this.filterFieldsRequestModels.length > 0) {
      this.saveFilterButtonDisabled = false;
      this.sendFilteredValue.emit(this.filterFieldsRequestModels);
      //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
    } else {      
      this.saveFilterButtonDisabled = true;
      this.sendFilteredValue.emit(this.filterFieldsRequestModels);
      //this._dataSharingService.sendFilteredValueCore(this.filterFieldsRequestModels);
    }
  }

  closeFilterSilde(message) {
    this.closeFilter.emit(message);   
    if(this.myFormGroup.dirty){      
      this.myFormGroup.markAsPristine();
    }
  }
  
  closeFilterSildeAfterSave(message) {
    this.closeFilterAfterSave.emit(message);
    if(this.myFormGroup.dirty){      
      this.myFormGroup.markAsPristine();
    }
  }

  clearFilterSilde(message, controlName?: string) {

    this.sendFromCoreFiltredName = "All "+this.orgModuleName+"";
    // if (this.sendFromCoreFiltredName != "All Core" && this.sendFromCoreFiltredName != "") {
    //   if (this.filterBindList != undefined && this.filterBindList.length > 0) {
    //     this.closeFilter.emit(message);
    //     this._dataSharingService.sendClearFilterEvent();
    //   }
    // }
    if (this.sendFromCoreFiltredName == "All "+this.orgModuleName+"") {
      this.tags = [];
      this.tagInput.nativeElement.value = ''; 
      // this.states = [];
      // this.stateInput.nativeElement.value = ''; 
      // this.stateCtrl.reset();
      // this.citys = [];
      // this.cityInput.nativeElement.value = '';  
      // this.cityCtrl.reset();   
      this.zipcodes = [];
      this.zipcodeInput.nativeElement.value = ''; 
      this.zipcodeCtrl.reset();
      // this.types = [];
      // this.typeInput.nativeElement.value = ''; 
      // this.typeCtrl.reset();
      this.importances = [];
      this.importanceInput.nativeElement.value = ''; 
      this.importanceCtrl.reset();
      this.saveFilterButtonDisabled = true;
      this.filterName = "";
      this.filterFieldsRequestModels = [];
      this.filterBindList = [];
      this.sendFromCoreFiltredName = "";
      this.defaultFilterFieldsList.forEach(element => {
        // if (element.fieldName == controlName) {
        element.label = "";
        //  }
      });
    
      this.clearApplyFilter.emit(message);      
      //this._dataSharingService.sendClearFilterEvent();
      this.myFormGroup.reset();
    }
    if (this.sendFromCoreFiltredName == "") {
      this.clearfilter = true;
      this.tags = [];
      this.tagInput.nativeElement.value = ''; 
      // this.states = [];
      // this.stateInput.nativeElement.value = ''; 
      // this.stateCtrl.reset();
      // this.citys = [];
      // this.cityInput.nativeElement.value = '';  
      // this.cityCtrl.reset();   
      this.zipcodes = [];
      this.zipcodeInput.nativeElement.value = ''; 
      this.zipcodeCtrl.reset();
      // this.types = [];
      // this.typeInput.nativeElement.value = ''; 
      // this.typeCtrl.reset();
      this.importances = [];
      this.importanceInput.nativeElement.value = ''; 
      this.importanceCtrl.reset();
      this.saveFilterButtonDisabled = true;
      this.filterName = "";
      this.filterBindList = [];
      this.filterFieldsRequestModels = [];    
     // this._dataSharingService.sendClearFilterEvent();
      this.clearApplyFilter.emit(message);
      this.myFormGroup.reset();
    }

  }

  closefilter() {
    this.filterName = "";
    this.dialog.closeAll();
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.closeFilterSilde(false);
    }
  }

  
}
